<template>
  <div class="max_box" :style="'min-height:' + height + 'px;'">
    <p style="font-size: 16px;font-weight: bold;font-family: '苹方';margin-bottom: 12px;">发票信息维护</p>
    <div class="add_new_con">
      <b2b-button style="width: 190px;height: 40px;line-height: 40px;" @click="addNewInvoice">
        添加发票抬头
      </b2b-button>
    </div>

    <div class="con_data_box">
      <el-table :data="invoices">
        <el-table-column prop="invoiceTitle" label="发票抬头" width="250">
        </el-table-column>
        <el-table-column prop="taxIdentifyNumber" label="纳税识别号" width="220">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span style="color:#1e50f0;cursor: pointer;margin-right: 10px" @click="showEdit(scope.row)">编辑</span>
            <el-popconfirm title="确认要删除吗？" @onConfirm="delInvoice(scope.row)">
              <span slot="reference" style="color:red;cursor: pointer;">删除</span>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog title="发票信息填写" :visible.sync="dialogVisible" width="750px">
        <div class="dialog_box">
          <InvoiceEdit ref="invoiceRef"/>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提 交</el-button>
      </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import InvoiceEdit from './InvoiceEdit.vue'

export default {
  name: 'UserInvoiceManage',
  components: {InvoiceEdit},
  data () {
    return {
      partnerInfo: {},
      headers: {},
      invoices: [],
      dialogVisible: false,
      height: 0
    }
  },
  created () {
    this.partnerInfo = JSON.parse(this.$common.isLogin())
    this.headers = {accessToken: this.partnerInfo.token}
    if (!this.partnerInfo) {
      this.$message.warning('请登录后再查看')
      this.$router.push('/login')
    }
    this.height = this.$common.getScreenInfo().height - 90 - 40
    this.getB2BInvoiceBasicInfos()
  },
  methods: {
    async getB2BInvoiceBasicInfos () {
      const {data: result} = await this.$http.get('/b2b/getB2BInvoiceBasicInfos', {headers: this.headers})
      if (result.code !== 200) return this.$message.error(result.message)
      this.invoices = result.data
    },
    addNewInvoice () {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs['invoiceRef'].init('', {})
      })
    },
    showEdit (row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs['invoiceRef'].init('', row)
      })
    },
    async submit () {
      const invoice = this.$refs['invoiceRef'].invoice
      const errMsg = this.checkForm(invoice)
      if (errMsg) return this.$message.warning(errMsg)
      const {data: result} = await this.$http.post('/b2b/saveB2BInvoiceBasicInfo', invoice, {headers: this.headers})
      if (result.code !== 200) return this.$message.error(result.message)
      this.$message.success('保存成功')
      await this.getB2BInvoiceBasicInfos()
      this.dialogVisible = false
    },
    checkForm (form) {
      if (!form.invoiceTitle) return '请输入公司名称(发票抬头)'
      if (!form.taxIdentifyNumber) return '请输入公司税号'
      if (!this.checkTaxpayerId(form.taxIdentifyNumber)) return '请输入正确的税号'
      if (!(form.companyAddress && form.companyPhone && form.accountBankName && form.accountBankid ||
        (!form.companyAddress && !form.companyPhone && !form.accountBankName && !form.accountBankid))) {
        return '开增值税发票需提完整的信息'
      }
      if (!form.checkTakerPhone) return '请输入收票人手机'
      if (!form.checkTakerEmail) return '请输入收票人邮箱'
    },
    checkTaxpayerId (taxpayerId) {
      if (!taxpayerId || taxpayerId.length !== 18) {
        return false
      }
      return /^[A-Z0-9]+$/.test(taxpayerId)
    },
    async delInvoice (row) {
      const {data: result} = await this.$http.delete(`/b2b/deleteB2BInvoiceBasicInfo?invoiceBaiscId=${row.invoiceBaiscId}`, {headers: this.headers})
      if (result.code !== 200) return this.$message.error(result.message)
      this.$message.success('删除成功')
      await this.getB2BInvoiceBasicInfos()
    }
  }
}
</script>

<style scoped lang="less">
.max_box {
  min-height: 325px;
  padding: 20px;
  background-color: #fff;

  .add_new_con {
    display: flex;
    justify-content: right;
  }

  .con_data_box {
    margin-top: 20px;
  }

  /deep/ .el-table th,
  .el-table tr {
    background-color: #f7f7f7;
    font-size: 13px;
  }

  /deep/ .el-dialog__header {
    background-color: #fff;
  }

  /deep/ .el-dialog__title {
    color: #303133;
  }

  /deep/ .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  /deep/ .el-form-item__label {
    height: 30px;
    line-height: 30px;
  }

  /deep/ .el-dialog__body {
    padding: 0 20px;
  }

  /deep/ .el-table td,
  .el-table th {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/components/UserInvoiceManage.vue